export const Services = () => {
    return <>
            {/* <!-- Page Header Start --> */}
        <div  className="container-fluid page-header py-5">
            <div  className="container text-center py-5">
                <h1  className="display-2 text-white mb-4 animated slideInDown">Our Services</h1>
                <nav aria-label="breadcrumb">
                    <ol  className="breadcrumb justify-content-center mb-0 animated slideInDown">
                        <li  className="breadcrumb-item"><a href="#">Home</a></li>
                        <li  className="breadcrumb-item"><a href="#">Pages</a></li>
                        <li  className="breadcrumb-item text-white" aria-current="page">Services</li>
                    </ol>
                </nav>
            </div>
        </div>
        {/* <!-- Page Header End --> */}


       {/* <!-- Services Start --> */}
        <div class="container-fluid services py-5">
            <div class="container text-center py-5">
                <div class="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
                    <h5 class="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">Our Services</h5>
                    <h1 class="display-5">Creating Impact Through Care & Community Support</h1>
                </div>
        <div className="row g-5">

            {/* Health Services */}
            <div className="col-xxl-6 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".3s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-notes-medical fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Health Services</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                        Providing free medical camps, healthcare support, and health checkups for underserved communities. Our goal is to improve access to quality healthcare and promote healthier lifestyles for individuals and families.
                    </p>
                </div>
            </div>

            {/* Education Support */}
            <div className="col-xxl-6 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".5s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-graduation-cap fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Education Support</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                      Supporting students through educational programs, learning resources, and academic development initiatives. We strive to create opportunities that empower young minds and help build a brighter future.
                    </p>
                </div>
            </div>

            {/* Community Awareness */}
            <div className="col-xxl-6 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".7s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-bullhorn fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Community Awareness</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                        Promoting health, hygiene, and social awareness through outreach
                        programs and workshops.Promoting health, hygiene, and social awareness through outreach programs, workshops, and educational campaigns. We work to encourage informed decisions and positive change within communities.
                    </p>

                </div>
            </div>

            {/* Community Welfare */}
            <div className="col-xxl-6 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".9s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-hand-holding-heart fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Community Welfare</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                      Helping families in need through welfare projects, charitable support, and community development activities. Our initiatives focus on improving well-being, fostering hope, and strengthening communities.
                    </p>

                </div>
            </div>

            </div>
                {/* <button type="button" class="btn btn-primary border-0 rounded-pill px-4 py-3 mt-4 wow fadeInUp" data-wow-delay=".3s">More Services</button> */}
            </div>
        </div>
        {/* <!-- Services End --> */}
    </>
}